import {CostItem} from '../types/CostItem';

export const getDataForWaterfallChart = (data: CostItem[]) =>
  data
    .filter((item) => Math.abs(item.value) > 0)
    .reduce<(CostItem & {visibleValue: number; basePosition: number})[]>((acc, item, index) => {
      if (index === 0) {
        return [
          {
            ...item,
            visibleValue: item.value,
            basePosition: 0,
          },
        ];
      } else {
        const prevSum = acc[index - 1].basePosition + acc[index - 1].visibleValue;
        return [
          ...acc,
          {
            ...item,
            visibleValue: item.value,
            basePosition: prevSum,
          },
        ];
      }
    }, []);
